function getSafeId(uid, errorMessage) {
  return function (value) {
    if (typeof value !== "string" || value.trim().length === 0) {
      throw new Error(errorMessage);
    }

    return "".concat(uid, "-").concat(value);
  };
}

export { getSafeId };